import API from './api';

export const downloadReport = async (endpoint, params, fallback) => {
  const response = await API.get(endpoint, { params, responseType: 'blob' });
  const disposition = response.headers?.['content-disposition'] || '';
  const filename = /filename="([^"]+)"/.exec(disposition)?.[1] || fallback;
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  anchor.href = url; anchor.download = filename; document.body.appendChild(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};